export default __webpack_public_path__ + "static/media/questionnaires_icon.390051e6.svg";